var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcHome01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "home-01"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2029 6.41868C18.086 6.33961 17.9141 6.33961 17.7972 6.41868L6.09715 14.331C6.01782 14.3846 6.00001 14.4476 6.00001 14.4835V29.2917C6.00001 29.8113 6.46535 30.3594 7.20001 30.3594H28.8C29.5347 30.3594 30 29.8113 30 29.2917V14.4835C30 14.4476 29.9822 14.3846 29.9029 14.331L18.2029 6.41868ZM16.1166 3.93359C17.2487 3.16797 18.7513 3.16797 19.8835 3.93359L31.5835 11.8459C32.4538 12.4345 33.0001 13.4111 33.0001 14.4835V29.2917C33.0001 31.6084 31.0477 33.3594 28.8 33.3594H7.20001C4.95232 33.3594 3 31.6084 3 29.2917V14.4835C3 13.4111 3.54623 12.4345 4.41657 11.8459L5.25686 13.0884L4.41657 11.8459L16.1166 3.93359ZM18 18.1719C16.9645 18.1719 16.125 19.0114 16.125 20.0469C16.125 21.0824 16.9645 21.9219 18 21.9219C19.0356 21.9219 19.875 21.0824 19.875 20.0469C19.875 19.0114 19.0356 18.1719 18 18.1719ZM13.125 20.0469C13.125 17.3545 15.3076 15.1719 18 15.1719C20.6924 15.1719 22.875 17.3545 22.875 20.0469C22.875 22.7393 20.6924 24.9219 18 24.9219C15.3076 24.9219 13.125 22.7393 13.125 20.0469Z",
    fill: "#B6BFCB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHome01);
export default __webpack_public_path__ + "static/media/ic-home-01.3785152b75d7c0890072f2392cc3efa2.svg";
export { ForwardRef as ReactComponent };